import React, { useCallback, useRef, useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from '@mui/material';

/** Panel Firebase push ops şifresi (geçici) */
export const FIREBASE_PUSH_PASSWORD = 'Admin123!';

/**
 * Promise-based password gate for any Firebase push.
 * Usage: const { requirePushPassword, PushPasswordDialog } = useFirebasePushAuth();
 * if (!(await requirePushPassword())) return;
 */
export function useFirebasePushAuth() {
  const [open, setOpen] = useState(false);
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const resolverRef = useRef(null);

  const requirePushPassword = useCallback(() => {
    setPassword('');
    setError('');
    setOpen(true);
    return new Promise((resolve) => {
      resolverRef.current = resolve;
    });
  }, []);

  const finish = (ok) => {
    setOpen(false);
    setPassword('');
    setError('');
    const resolve = resolverRef.current;
    resolverRef.current = null;
    if (resolve) resolve(ok);
  };

  const handleConfirm = () => {
    if (password !== FIREBASE_PUSH_PASSWORD) {
        setError('Şifre hatalı. Yazma yapılamaz.');
      return;
    }
    finish(true);
  };

  const PushPasswordDialog = (
    <Dialog open={open} onClose={() => finish(false)} maxWidth="xs" fullWidth>
      <DialogTitle>Yazma izni — Şifre</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Şifre olmadan Postgres veya Firebase&apos;e yazılmaz. Devam için admin şifresini gir.
        </Typography>
        <TextField
          autoFocus
          fullWidth
          type="password"
          label="Şifre"
          value={password}
          onChange={(e) => {
            setPassword(e.target.value);
            setError('');
          }}
          error={Boolean(error)}
          helperText={error || ' '}
          onKeyDown={(e) => {
            if (e.key === 'Enter') handleConfirm();
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={() => finish(false)}>İptal</Button>
        <Button variant="contained" color="warning" onClick={handleConfirm}>
          Push&apos;a izin ver
        </Button>
      </DialogActions>
    </Dialog>
  );

  return { requirePushPassword, PushPasswordDialog };
}

export default useFirebasePushAuth;
